export default {
  props: ['id'],
  computed: {
    user() {
      return this.$store.state.user;
    },
    results() {
      return this.$store.state.courses.testResultsList;
    },
  },
  methods: {
    correctPercent(correct, all) {
      return all > 0 ? Math.round((correct / all) * 100) : 0;
    },
  },
  mounted() {
    this.$store.dispatch('courses/GetResultsList', { profile_id: this.user.profile_id, test_id: this.id });
  },
};
